import { useState, useCallback } from 'react';

const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    message: '',
    type: 'error',
  });

  const showSnackbar = useCallback((message, type = 'error') => {
    setSnackbar({
      isOpen: true,
      message,
      type,
    });
  }, []);

  const hideSnackbar = useCallback(() => {
    setSnackbar((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    hideSnackbar,
  };
};

export default useSnackbar;